import Axios from 'axios';
import api from './api';

export interface DocuSignAssinantes {
  name: string;
  email: string;
  status: string;
  signedDateTime: string;
}

export interface PutDocuSignID{
  envelopeId?: string;
  envelopeIdCT?: string;
}
export interface DocuSign{
  signers?: DocuSignAssinantes;
}

export const getAssinantes = (envelopeId: string, ordemCompraId: string) =>
  api.get<DocuSign>(`docuSign/GetEnvelopeInfoDocuSign/${envelopeId}/${ordemCompraId}`);

export const salvarDocuSignId = (ordemCompraId: any,values: PutDocuSignID) =>
api.put(`docuSign/SalvarDocuSignId/${ordemCompraId}`,values);

export const atualizarDocuSignOc = (ordemCompraId: any) =>
api.get(`docuSign/AtualizarOrdemCompraStatusAprovacaoDocuSign/${ordemCompraId}`);
